/**
 * Roles canónicos del sistema RBAC de Rendafin.
 *
 * Source of truth: `api-rendafin/src/modules/migration/data/roles.json`
 * (versionado en git desde ADR-0004). Los `name` deben coincidir EXACTAMENTE
 * con los del backend.
 *
 * Histórico:
 * - ADR-0003 estableció `'client'` como predicado canónico.
 * - ADR-0009 (2026-05-09) renombró `'client'` → `'Client'` para alinear con
 *   convención PascalCase del resto.
 *
 * Uso: importar y comparar contra `permissions.name` o `role.name`. Evita
 * strings sueltos para que typos se detecten en compile-time y futuros
 * renames del backend se propaguen con un solo edit.
 *
 * En templates HTML: el componente debe exponer el enum como property
 * pública (`public UserRole = UserRole`) para poder referenciarlo desde
 * el binding (ej. `[disabled]="role === UserRole.BROKER"`).
 */
export enum UserRole {
  ADMIN = 'Admin',
  OPERACIONES = 'Operaciones',
  FINANZAS = 'Finanzas',
  CONTABILIDAD = 'Contabilidad',
  SELLER = 'Seller',
  BROKER = 'Broker',
  MASTER_BROKER = 'MasterBroker',
  LEGAL = 'Legal',
  CLIENT = 'Client',
}
